function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3ccab0;\n      }\n\n      .cls-2 {\n        fill: #fff;\n        stroke: #fff;\n        stroke-width: 0.6px;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Frame_14",
  "data-name": "Frame 14",
  transform: "translate(-14 -7)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  className: "cls-1",
  cx: 17,
  cy: 17,
  r: 17,
  transform: "translate(14 7)"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  className: "cls-2",
  d: "M33.98,15.923a.781.781,0,0,0-.558,1.46,7.264,7.264,0,1,1-5.189,0,.781.781,0,1,0-.558-1.459,8.827,8.827,0,1,0,6.306,0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  className: "cls-2",
  d: "M30.828,13a.781.781,0,0,0-.781.781v7.65a.781.781,0,1,0,1.562,0v-7.65a.781.781,0,0,0-.78-.782Z"
}));

function SvgDeviceOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceOn);
export default __webpack_public_path__ + "static/media/device-on.18cd846f.svg";
export { ForwardRef as ReactComponent };